
import { TextBoxItem } from "components/Input/TextBox";
import Grid from "@mui/material/Grid";
import { FormProvider, useForm } from "react-hook-form";
import { BtnSearch } from "components/Button/ButtonAll";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { useState } from "react";
import { Box, Divider, Pagination, PaginationItem, Stack, Typography, styled } from "@mui/material";
import CardFrom from "components/CardContent/CardFrom";
import ExcelIcon from "../../../../src/assets/images/DocTypeIcon/Excel.svg";
import PDFIcon from "../../../../src/assets/images/DocTypeIcon/PDF.svg";
import PPTIcon from "../../../../src/assets/images/DocTypeIcon/PPT.svg";
import WordIcon from "../../../../src/assets/images/DocTypeIcon/Word.svg";
import usePagination from 'components/Pagination/Pagination';
import { useNavigate } from "react-router";

const Searchsite = () => {
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const [arrDataSearch, setarreDatasearch] = useState([]);
    const [Count, setCount] = useState(0);
    const [Mode, setMode] = useState(1);
    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });
    const onSubmit = () => {
        setMode(2);
        let sSearch = form.getValues("sSearch")
        AxiosFn.Get(`Home/GetSearchSite`, { sSearch: sSearch }, (result) => {
            setarreDatasearch(result.lstDataSearch || []);
            setCount(result.nCount);
        })

    }


    //#region Page All      
    const PER_PAGE = 6;
    let [page, setPage] = useState(1);
    const count = Math.ceil(arrDataSearch.length / PER_PAGE);

    const _DATA = usePagination(arrDataSearch, PER_PAGE);


    const handleChange = (e, p) => {
        setPage(p);
        _DATA.jump(p);
    };

    const pageNext = () => {
        return <>{`${I18n.SetText("Leave.sNext")}`}</>;
    };

    const pagePrevious = () => {
        return <>{`${I18n.SetText("Leave.sPrevious")}`}</>;
    };

    const handleOpenFile = (sFilePath, nType, sID) => {
        if (nType === 1) {
            if (sFilePath) {
                let sUrl = process.env.REACT_APP_API_URL + "/" + sFilePath;
                window.open(sUrl, "_blank", "noreferrer");
            }
        } else {
            navigate(`/GalleryDetail?sID=${encodeURI(sID)}`);
        }

    };
    return (
        <>
            <FormProvider {...form}>
                <Grid item xs={12} md={12} sx={{ marginTop: 3 }}>
                    <Grid container spacing={2} justifyContent={"center"} >
                        <Grid item xs={12} md={8}  >
                            <TextBoxItem
                                name="sSearch"
                                label='พิมพ์คำค้นหา'
                                maxLength={250}
                                id={"sSearch"}
                                required={false}
                                type={'text'}

                            />
                        </Grid>
                        <Grid item xs={1} md={1} >
                            <BtnSearch
                                id={"btnSave"}
                                onClick={form.handleSubmit(
                                    () => onSubmit()  )}
                            />
                        </Grid>
                    </Grid>
                    {_DATA.currentData().length > 0 ? (
                        <Grid item xs={12} md={12} >
                            <Grid item container justifyContent={"center"} >
                                <Grid item xs={12} md={9} style={{ marginTop: 30 }} >
                                    <Typography fontSize={16} color="text.secondary">แสดงผลทั้งหมด  {Count} รายการ</Typography>
                                    <Divider />
                                </Grid>
                            </Grid>
                            <Grid item container spacing={2} justifyContent={"center"} style={{ marginTop: 10 }} >
                                {
                                    _DATA.currentData().map(m => {

                                        return (
                                            <Grid item container key={m.nID + m.sName} justifyContent={"center"} style={{ marginTop: 10 }}>
                                                <CardFrom bgColor='#fbfbfb' minHeightCard='100px' widthCard="75%" >
                                                    <Grid item xs={12} md={12} container spacing={1}>
                                                        <Grid item xs={12} md={12} >
                                                            <div
                                                                onClick={() => handleOpenFile(m.sFilePath, m.nType, m.sID)}
                                                                style={{
                                                                    color: "blue",
                                                                    marginLeft: 10,
                                                                    cursor: "pointer",
                                                                    fontWeight: 500
                                                                }} >{m.sName}</div>
                                                        </Grid>
                                                        <Grid item container xs={12} md={12} style={{ marginTop: 5 }}>
                                                            {m.sImg && (
                                                                <Grid item xs={12} md={1} >
                                                                    <img
                                                                        src={process.env.REACT_APP_API_URL + m.sImg}
                                                                        alt={''}
                                                                        style={{
                                                                            width: 90,
                                                                            height: 80,
                                                                            borderRadius: '10%',
                                                                            marginLeft: 10,
                                                                        }}
                                                                    />
                                                                </Grid>
                                                            )}
                                                            <Grid item xs={12} md={11} >
                                                                <Typography fontSize={14} style={{ marginLeft: 20 }}> {m.sDescription}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </CardFrom>
                                            </Grid>
                                        );
                                    })
                                }
                            </Grid>
                            <Grid item container justifyContent={"center"} xs={12} md={12} spacing={5} style={{ marginTop: 30 }}>
                                <Stack spacing={2} style={{ margin: "1rem auto 2rem", alignItems: "center" }}>
                                    <Pagination
                                        count={count}
                                        page={page}
                                        onChange={handleChange}
                                        color="primary"
                                        renderItem={(item) => <PaginationItem components={{ previous: pagePrevious, next: pageNext }} {...item} />}
                                    />
                                </Stack>
                            </Grid>
                        </Grid>

                    ) :
                        <Grid item container justifyContent={"center"} >
                            <Grid item xs={12} md={9} style={{ margin: "1em 5em 15em 5em" }} >
                                <Typography sx={{ fontSize: "24px", color: "#aeb4b7" }}>
                                    ไม่พบรายการที่ค้นหา
                                </Typography>
                                <Divider />
                            </Grid>
                        </Grid>
                        // <Box
                        //     sx={{
                        //         display: "flex",
                        //         alignItems: "center",
                        //         flexDirection: "column",
                        //         m: "10em 5em 10em 5em"
                        //     }}
                        // >
                        // </Box>
                    }

                </Grid >
            </FormProvider >
        </>
    )

}
export default Searchsite